import { createSelector } from '@reduxjs/toolkit';
import {
  selectProjectsDetails,
  selectOptionsPercentTotal,
  selectOptionsPlusTotal,
} from '../project/projectSelectros';

export const selectDesign = createSelector(
  selectProjectsDetails,
  projectsDetails => projectsDetails?.design || {}
);

export const selectDesignCalculationParams = createSelector(
  selectDesign,
  projectOther => projectOther.calculationOptions || {}
);

export const selectDesignPagesTotal = () => {
  return {
    discount: 0,
    totalPricePages: 0
  };
};

export const selectDesignOptionsTotal = createSelector(
  selectDesignPagesTotal,
  selectOptionsPlusTotal,
  selectOptionsPercentTotal,
  ({totalPricePages}, totalPricePlusOptions, totalPricePercentOptions) => {
    const  totalPriceOfPercent = Math.ceil((totalPricePercentOptions / 100) * totalPricePages);
    return totalPriceOfPercent + totalPricePlusOptions;
  }
);

export const selectDesignTotal = createSelector(
  selectDesignPagesTotal,
  selectDesignOptionsTotal,
  ({totalPricePages}, totalPriceOptions) => totalPricePages + totalPriceOptions
);

export const selectDesignTotalForAsap = createSelector(
    selectDesignTotal,
    (totalPrice) => {
      return totalPrice / 2;
    }
);

export const selectDesignEta = () => ({
  etaText: '',
  etaIsExists: false
});

export const selectDesignDiscount = () => ({
  discountIsExists: false,
  discountText: '',
  discountPrice: 0,
});
